import React, { useEffect, useMemo, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { getPlans } from '../../Utils/backStageApi';
import { PlanItem, PlanSortField, PlanTable } from '../../Components/Plan/PlanTable';
import { PlanActionBar } from '../../Components/Plan/PlanActionBar';
import { checkAuth } from '../../Utils/common';

const PlanManagerPage: React.FC = () => {
  const history = useHistory();
  const [plans, setPlans] = useState<PlanItem[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  const [sortField, setSortField] = useState<PlanSortField>('annual_limit');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  useEffect(() => {
    checkAuth();
    getPlans().then((data) => {
      if (!data?.list) return;
      setPlans(data.list);
    });
  }, []);

  const handleSortToggle = (field: Exclude<PlanSortField, null>) => {
    if (sortField === field) {
      setSortDirection((p) => (p === 'desc' ? 'asc' : 'desc'));
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };

  const filtered = useMemo(() => {
    const f = plans.filter((p) => {
      const q = searchText.trim();
      if (!q) return true;
      return p.code.toLowerCase().includes(q.toLowerCase()) || p.name_zh.includes(q);
    });

    if (!sortField) return f;

    const getValue = (p: PlanItem) =>
      sortField === 'annual_limit' ? (p.annual_limit === null ? Infinity : p.annual_limit) : p.issuer_count;

    return [...f].sort((a, b) => {
      const diff = getValue(a) - getValue(b);
      return sortDirection === 'desc' ? -diff : diff;
    });
  }, [plans, searchText, sortField, sortDirection]);

  return (
    <Flex w="100%" direction="column" align="center" pt="50px" pb="100px">
      <Text
        fontFamily="'Open Sans', sans-serif"
        fontSize="30px"
        fontWeight={600}
        lineHeight="133%"
        letterSpacing="0.01em"
        color="#000000"
        textAlign="center"
      >
        方案管理
      </Text>

      <PlanActionBar
        mt="50px"
        searchText={searchText}
        onSearchChange={setSearchText}
        onAdd={() => history.push('/bs/plan/create')}
      />

      <PlanTable
        mt="22px"
        plans={filtered}
        sortField={sortField}
        sortDirection={sortDirection}
        onSortToggle={handleSortToggle}
      />
    </Flex>
  );
};

export default PlanManagerPage;
